import { StaticConst } from "@/constants/staticConst";
import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { SendLetterResponseDTO } from "./models";

export class RemoveAttachesApi {
  static removeAttaches = async (attachedFiles: number[]) => {
    const response = GbApiRequestService.post(
      "userRpc",
      new URLSearchParams({
        type: JSON.stringify({
          dataMap: {
            attachedFilesId: attachedFiles,
            type: StaticConst.EAttachedFileType.ORDINARY,
          },
          processorClass: "RemoveFile",
        }),
      }),
    );

    return await withSchemaValidation(response, SendLetterResponseDTO);
  };
}
